// constants/StaticLabels.js

export const StaticLabels = {
    US: {
        Disclaimer: 'We respect your concerns about privacy and value the relationship we have with you. You can use this form to submit a request regarding your personal data. ELC will process your request in accordance with applicable law.',
        PrivacyPolicyLabel: 'For more information on how we process your personal data and our privacy practices, please see our ',
        EmailInputLabel: 'Email',
        FormSuccessLabel: 'Your request is confirmed!',
        FormErrorLabel: 'There was an error submitting your request. Please try again later.',
        SubmitButton: 'Unsubscribe',
    },
    UK: {
        Disclaimer: 'We respect your concerns about privacy and value the relationship we have with you. You can use this form to submit a request regarding your personal data. ELC will process your request in accordance with applicable law.',
        PrivacyPolicyLabel: 'For more information on how we process your personal data and our privacy practices, please see our ',
        EmailInputLabel: 'Email',
        FormSuccessLabel: 'Your request is confirmed!',
        FormErrorLabel: 'There was an error submitting your request. Please try again later.',
        SubmitButton: 'Unsubscribe',
    },
    FR: {
        Disclaimer: 'Nous respectons vos préoccupations concernant la confidentialité et valorisons la relation que nous avons avec vous. Vous pouvez utiliser ce formulaire pour soumettre une demande concernant vos données personnelles. ELC traitera votre demande conformément à la loi applicable.',
        PrivacyPolicyLabel: 'Pour plus d\'informations sur la façon dont nous traitons vos données personnelles et nos pratiques de confidentialité, veuillez consulter notre ',
        EmailInputLabel: 'Email',
        FormSuccessLabel: 'Votre demande est confirmée!',
        FormErrorLabel: 'Une erreur s\'est produite lors de la soumission de votre demande. Veuillez réessayer plus tard.',
        SubmitButton: 'Se désabonner',
    }
}